import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Flex, Stack } from "@mantine/core";
import { useParams, Link, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ErrorView, PageTitle, Subnav } from "@components/shared";
import { LogoUpload } from "@components/Asset";
import {
  AffiliateForm,
  AffiliateStatus,
  AffiliateEntityJoins,
} from "@components/Affiliate";

import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

export default function AffiliateDetail() {
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const params = useParams();
  const { id } = params;
  const { t } = useTranslation();
  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios
      .get(`/affiliates/${id}/`)
      .then(({ data }) => {
        setInfo(data.response[0]);
      })
      .catch((err) => {
        // setError(err);
        setInfo({
          name: "ACME",
        });
      });
  }

  if (error) {
    return <ErrorView text={error} />;
  }

  if (!info) return null;

  return (
    <div>
      <Flex gap="xs">
        <LogoUpload
          affiliateId={id}
          onSuccess={fetchData}
          url={info.logo_url}
        />
        <PageTitle
          title={info.name}
          subtitle={<React.Fragment>Affiliate</React.Fragment>}
          icon={entityIcon.affiliate()}
          iconColor={entityColor.affiliate}
        />
      </Flex>
      <Subnav
        links={[
          { to: `/affiliates/${id}`, text: t("common:detail") },
          { to: `/affiliates/${id}/joins`, text: "Joins" },
        ]}
        buttonColor={entityColor.affiliate}
      />
      <Routes>
        <Route
          path="/"
          element={
            <Stack>
              <Card>
                <AffiliateForm
                  id={id}
                  name={info.name}
                  classification={info.classification}
                  variety={info.variety}
                  onSuccess={() => {
                    fetchData();
                  }}
                />
              </Card>
              <Card>
                <AffiliateStatus
                  affiliateId={id}
                  fetchData={fetchData}
                  status={info.status}
                />
              </Card>
            </Stack>
          }
        />
        <Route
          path="/joins"
          element={
            <AffiliateEntityJoins affiliateId={id} fetchData={fetchData} />
          }
        />
      </Routes>
    </div>
  );
}
